import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Perfil} from '../model/perfil/perfil.model';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/perfil`;

  buscarPerfisPorGrupo(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(this.urlBase);
  }

  salvarPerfil(perfil: Perfil): Observable<Perfil> {
    return this.http.post<Perfil>(this.urlBase, perfil);
  }

  buscarPerfisGrupo(grupoId: number): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(`${this.urlBase}/buscar/grupo/${grupoId}`);
  }

  buscarPerfilSelectDoGrupo(grupoId: number): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/buscar/select/grupo/${grupoId}`);
  }
}
